<template>
  <dialog-template
    :headerTitle="'选择计价单位'"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :width="'400px'"
  >
    <!-- <div class="recent-use" v-if="units.recent && units.recent.length > 0">
      <p>最近使用：</p>
      <div class="unit-wrapper">
        <span
          @click="selectUnit(item)"
          v-for="item in units.recent"
          :key="item.id"
          :class="{active: curUnitId === item.id}"
        >{{ item.name }}</span>
      </div>
    </div> -->
    <div class="units" v-if="units.all && units.all.length > 0">
        <template v-if="weighUnit.length > 0">
            <p>计重单位：</p>
            <div class="unit-wrapper">
                <span
                  @click="selectUnit(item)"
                  v-for="item in weighUnit"
                  :key="item.id"
                  :class="{active: curUnitId === item.id}"
                >{{ item.name }}</span>
            </div>
        </template>
        <template v-if="countUnit.length > 0">
            <p>计数单位：</p>
            <div class="unit-wrapper">
                <span
                  @click="selectUnit(item)"
                  v-for="item in countUnit"
                  :key="item.id"
                  :class="{active: curUnitId === item.id}"
                >{{ item.name }}</span>
            </div>
        </template>
    </div>
  </dialog-template>
</template>

<script>
import clone from 'lodash/cloneDeep'
import $fetch from '@/api'
import { openMessage } from '../../../../utils/system'

export default {
  data() {
    return {
      dialogVisible: false,
      units: {
          recent: [],
          all: []
      },
      curUnitId: null
    }
  },
  computed: {
      countUnit() {
          return this.units.all.filter(el => !(this.filterArr.includes(el.id)))
      },

      weighUnit() {
          return this.units.all.filter(el => this.filterArr.includes(el.id))
      }
  },
  created() {
    const units = sessionStorage.getItem("UNITS")
    this.filterArr = [2, 4]
    if (!units) {
        this.getAllUnits()
            .then(data => {
                if (data) {
                    this.units.all = clone(data)
                    sessionStorage.setItem("UNITS", JSON.stringify(this.units))
                }
            })
    } else {
        this.units = JSON.parse(units)
    }
  },
  methods: {
    open(curUnit) {
      this.curUnitId = curUnit.id
      this.dialogVisible = true
    },

    getAllUnits() {
        return $fetch.post({
            url: '/goods/getunit'
        }).then(data => {
            console.log('all units', clone(data))
            return data
        }).catch(e => openMessage('error', e.message || '获取单位失败'))
    },

    selectUnit(item) {
      this.$emit("selected", item)
      this.dialogVisible = false
      this.curUnitId = item.id
      const result = this.units.recent.find(newItem => newItem.id === item.id)
      if (!result) {
        this.units.recent.push(item)
        sessionStorage.setItem("UNITS", JSON.stringify(this.units))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.recent-use,
.units {
  color: #333;

  > p {
    height: 20px;
    line-height: 20px;
    margin-bottom: 8px;
  }

  .unit-wrapper > span {
    display: inline-block;
    width: 36px;
    height: 36px;
    line-height: 36px;
    margin: 0 12px 8px 0;
    text-align: center;
    background: #f7f7f7;
    border-radius: 4px;
    box-sizing: border-box;
    ;
    cursor: pointer;

    &:nth-of-type(8n) {
      margin-right: 0;
    }

    &:hover {
      background: rgba(0, 150, 136, 0.2);
    }

    &.active {
      background: rgba(0, 150, 136, 0.2);
      border: 1px solid rgba(0, 150, 136, 1);
    }
  }
}
</style>
